<template>
  <!-- 暴露数鑑定書 -->
  <div class="block-bakuro-num-appraisals" :style="styles">
    <div class="appraisal-area" v-if="!!resultData && Object.keys(resultData).length > 0">
      <h2 class="appraisal-area-title">暴露数鑑定書</h2>
      <div class="image-area">
        <img :src="resultData.result2['image1']" alt="">
        <img :src="resultData.result2['image2']" alt="">
      </div>
      <div class="link-area">
        <a
          v-for="(item, idx) in itemsList"
          :key="idx"
          :href="item.url"
          :class="{new: +item.is_new > 0}"
          @click.prevent="onLinkItemClick"
        >{{item.title}}</a>
      </div>
    </div>
    <regist-birthdate :csrf-token="csrfToken" v-else />
  </div>
</template>

<script>
import RegistBirthdate from './RegistBirthdate'

export default {
  name: 'BlockBakuroNumApprisal',
  components: {
    RegistBirthdate,
  },
  props: {
    itemsList: {
      type: Array,
      required: true,
    },
    resultData: {
      //type: Object,
      type: [Object, Array],
      default() {
        return null
      }
    },
    csrfToken: {
      type: String,
      default() {
        return ''
      }
    },
    colorScheme: {
      type: Object,
      default() {
        return {}
      }
    },
  },
  computed: {
    styles() {
      return {
        '--key-color': this.colorScheme.keyColor,
        '--second': this.colorScheme.second,
        '--grad-start': this.colorScheme.gradStart,
        '--grad-end': this.colorScheme.gradEnd,
        '--mess-bg': this.colorScheme.messBg,
      }
    },
  },
  methods: {
    onLinkItemClick(e) {
      location.href = e.target.href
    }
  },
}
</script>

<style scoped lang="scss">
@import "../../../../../../sass/commons/commonVariables.scss";
@import "../../../../../../sass/commons/styles/fonts";

$l_col_keycolor: var(--key-color);
$l_col_second: var(--second);
$l_col_grad_start: var(--grad-start);
$l_col_grad_end: var(--grad-end);
$l_col_mess_bg: var(--mess-bg);


.block-bakuro-num-appraisals {
  .appraisal-area{
    background: #fff;
    margin: 0 20px 40px;
    padding: 24px 20px;
    border: 1px solid var(--key-color);
    .appraisal-area-title{
      border-bottom:1px solid var(--key-color) ;
      margin: 0 auto;
      margin-bottom:24px;
      //font-family: 'Hiragino Mincho Pro';
      @extend .source-han-serif-bold;
      //font-style: normal;
      //font-weight: 600;
      font-size: 24px;
      line-height: 24px;
      text-align: center;
      letter-spacing: 6px;
      color: var(--key-color);
      display: table;
      padding-bottom: 10px;
    }
    .image-area{
      margin: auto;
      display: flex;
      margin-bottom: 16px;
      justify-content: space-between;
      max-width: 300px;
      img{
        width: 140px;
        border-radius: 10px;
      }
    }
    .link-area{
      a {
        padding: 20px;
        color: $col_base_black;
        font-family: 'Hiragino Kaku Gothic Pro';
        font-style: normal;
        font-weight: 600;
        font-size: 14px;
        line-height: 20px;
        border-bottom:1px solid  #dadada;
        position: relative;
        display: block;
        text-decoration: none;
        @include mq('w580'){
          font-size: 16px;
        }
        &::before{
          content:'';
          border-top:2px solid var(--second);
          border-right:2px solid var(--second);
          position: absolute;
          width: 10px;
          height: 10px;
          right: 10px;
          top: 43%;
          transform: rotate(45deg);
        }
        &.new {
          &::after {
            content: "NEW";
            color: $l_col_keycolor;
            background: #eded67;
            font-weight: 600;
            font-size: 10px;
            line-height: 10px;
            padding: 3px;
            margin-left: 6px;
          }
        }
      }
    }
  }
  .regist-birthdate{
    padding: 0 24px 40px;
    background: none;
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/Products/houen/partials/BlockBakuroNumApprisal.vue